<div mat-dialog-content>
  <p>
    {{
      data.type === 'add'
        ? languageService.translate.instant('igo.geo.workspace.addConfirmation')
        : languageService.translate.instant(
            'igo.geo.workspace.deleteConfirmation'
          )
    }}
  </p>
</div>
<div mat-dialog-actions>
  <button matButton="elevated" color="primary" (click)="confirmedAction()">
    Ok
  </button>
  <button matButton="elevated" (click)="cancelAction()">
    {{ languageService.translate.instant('igo.geo.workspace.cancel') }}
  </button>
</div>
